module.exports = __webpack_public_path__ + "img/scene2-21.35baf7ea.jpg";